const $webStatus = $('.avalabilities-product .web-status');
const $price = $('.product__add-to-cart .product_price');
const $rootSku = $('.product__add-to-cart .root-sku');
const $variationsOptions = $('.variations_form .variations');
const $variationsOptionsInputs = $variationsOptions.find('select, input');
const $resetVariationsOptions = $('.variations_form .reset_variations');

const updateVariationsFormStyle = function(event) {
    var shouldAddClass = false;
    var oneVariationFieldIsEmpty = false;

    for(var i = 0; i < $variationsOptionsInputs.length; i ++) {
        if($variationsOptionsInputs.eq(i).val() !== '') {
            shouldAddClass = true;
        }
        else {
            oneVariationFieldIsEmpty = true;
        }
    }
    
    if(shouldAddClass) {
        $variationsOptions.addClass('variation-shown');
    }
    else {
        $variationsOptions.removeClass('variation-shown');
    }

    if(oneVariationFieldIsEmpty) {
        $rootSku.show();
    }
    else {
        $rootSku.hide();
    }
};

// Fired when the user selects all the required dropdowns / attributes
// and a final variation is selected / shown
$(".single_variation_wrap").on("show_variation", function(event, variation) {
    if(variation) {
        // Hide SKU of product to only display variation SKU
        $rootSku.hide();

        // Stock status update
        if($webStatus.length && $webStatus[0].hasAttribute('data-stock-statuses')) {
            let status = '';
            let statuses = JSON.parse($webStatus.attr('data-stock-statuses'));
            
            $webStatus.removeClass('status-instock status-onbackorder status-outofstock');
            
            if(variation.is_in_stock) {
                status = 'instock';
            }
            else if(variation.backorders_allowed) {
                status = 'onbackorder';
            }
            else if(!variation.is_in_stock) {
                status = 'outofstock';
            }

            if(status.length) {
                $webStatus.addClass(`status-${status}`);
                $webStatus.text(typeof statuses[status] !== undefined ? statuses[status] : '');
            }
        }

        // Price update
        if($price.length) {
            $price.html(variation.price_html);
        }

        updateVariationsFormStyle();
    }
});

// Fires whenever variation selects are changed
$(".variations_form").on("woocommerce_variation_select_change", updateVariationsFormStyle);

// Show SKU of product when variation SKU is hidden
$resetVariationsOptions.on('click', function() {
    $rootSku.show(); 
});